import React, { createContext, useContext, useState, useEffect } from 'react'
import fetchAPI from 'shared/fetchAPI'
import { STORE_ID } from 'pro/common/backendValues'

export const AbTestsContext = createContext()

const AbTestsProvider = ({ children }) => {
  const [abTests, setAbTests] = useState({})

  const _fetchAbTestStatus = async abTestKey => {
    try {
      const { enabled } = await fetchAPI(
        `/api/v3/ab_tests/${abTestKey}/${STORE_ID}`
      )
      return enabled
    } catch (error) {
      console.error(error)
    }
  }

  const isAbTestEnabled = async abTestKey => {
    if (abTests[abTestKey] === undefined) {
      const isEnabled = await _fetchAbTestStatus(abTestKey)
      setAbTests(prev => ({ ...prev, [abTestKey]: isEnabled }))
      return isEnabled
    }
    return abTests[abTestKey]
  }

  return (
    <AbTestsContext.Provider value={{ isAbTestEnabled }}>
      {children}
    </AbTestsContext.Provider>
  )
}

export function useAbTest(abTestKey) {
  const { isAbTestEnabled } = useContext(AbTestsContext)
  const [isLoading, setIsLoading] = useState(true)
  const [isEnabled, setIsEnabled] = useState(false)

  useEffect(() => {
    const fetchIsEnabled = async () => {
      const isEnabled = await isAbTestEnabled(abTestKey)
      setIsEnabled(isEnabled)
      setIsLoading(false)
    }
    fetchIsEnabled()
  }, [])

  return { isEnabled, isLoading }
}

export default AbTestsProvider
